export default __webpack_public_path__ + "static/media/bandcamp-light.cd8d4faa.svg";